import { useStoreState } from 'easy-peasy';
import { PropTypes } from 'prop-types';
import { useMemo, useEffect } from 'react';

import { getRibbonState } from '@ge/feat-monitor/util/data-filter';
import { useTableFilter } from '@ge/shared/data-hooks/use-table-filter';

import useSortedCaseTable from '../data-hooks/use-sorted-case-table';

function SortFilterAnomaliesWrapper({
  anomaliesData: cases,
  isUpdatedCases,
  isActionsTriggered,
  setCasesData,
  sortMetric,
  sortDirection,
  isLoading,
  isAuthorizedToViewTasks,
  type,
  filters,
  filterSequence,
  search,
}) {
  const sortedCases = useSortedCaseTable({ cases, sortDirection, sortMetric });
  const ribbonFilter = useStoreState(({ monitor }) => monitor.ribbonFilter);

  const getFilteredData = useMemo(
    () =>
      getRibbonState({
        isLoading,
        type,
        selected: ribbonFilter[type],
        data: sortedCases,
        isAuthorizedToViewTasks,
      }),
    [isLoading, type, sortedCases, ribbonFilter, isAuthorizedToViewTasks],
  );

  const { data = [], filterValues = [] } = useTableFilter({
    data: sortedCases,
    cases: getFilteredData?.data,
    filters,
    search,
    filterSequence,
  });

  useEffect(() => {
    setCasesData((prevState) => ({ ...prevState, anomalies: data, filterValues: filterValues }));
    isUpdatedCases && setCasesData((prevState) => ({ ...prevState, isUpdatedCases: false }));
    isActionsTriggered &&
      setCasesData((prevState) => ({ ...prevState, isActionsTriggered: false }));
  }, [setCasesData, data, filterValues, isUpdatedCases, isActionsTriggered]);

  return null;
}

export default SortFilterAnomaliesWrapper;

SortFilterAnomaliesWrapper.propTypes = {
  anomaliesData: PropTypes.any,
  setCasesData: PropTypes.any,
  isUpdatedCases: PropTypes.any,
  isActionsTriggered: PropTypes.any,
  sortMetric: PropTypes.any,
  sortDirection: PropTypes.any,
  isLoading: PropTypes.any,
  isAuthorizedToViewTasks: PropTypes.any,
  type: PropTypes.any,
  filters: PropTypes.any,
  filterSequence: PropTypes.any,
  search: PropTypes.any,
};
